import React, { useEffect, useState } from 'react';

import Paper from '@material-ui/core/Paper';

import { IGroupEnrollment, IHole } from '../../../../../store/player/games/store';
import { IDraft } from '../Utils/IDraft';
import ScorePicker from '../../Components/ScorePicker/ScorePicker';

interface IProps {
  draftScores: IDraft;
  editMode: boolean;
  enrollments: IGroupEnrollment[];
  hole: IHole | undefined;
  setScore: (teamId: number) => (value: number) => void;
}

const HoleScorerTeam: React.FunctionComponent<IProps> = props => {
  const { draftScores, editMode, enrollments, hole, setScore } = props;

  const [teamName, setTeamName] = useState('');
  const [gross, setGross] = useState(0);
  const [scorePickerIsDisabled, setScorePickerIsDisabled] = useState(false);

  useEffect(() => {
    setTeamName(enrollments.map(enrollment => enrollment.user.lastName).join(' / '));
  }, [enrollments]);

  useEffect(() => {
    const score = draftScores[enrollments[0].id];

    if (score) {
      const scoreOriginal = score.original;
      const scoreGross = score.gross;
      const scoreNotSaved = score.notSaved;

      if (scoreOriginal !== scoreGross && !scoreNotSaved) {
        setGross(scoreGross);
        setScorePickerIsDisabled(true);
      } else {
        setGross(scoreOriginal);
      }
    }
  }, [draftScores, enrollments]);

  return (
    <Paper className="scorer-paper">
      <div className="scorer-name">{teamName}</div>

      <div className="scorer-actions">
        <ScorePicker
          editMode={editMode}
          empty={!draftScores[enrollments[0].id] || draftScores[enrollments[0].id].empty}
          gross={gross}
          net={draftScores[enrollments[0].id] ? draftScores[enrollments[0].id].netScore : 0}
          onChange={setScore(enrollments[0].team)}
          par={hole ? hole.par : 0}
          disabled={scorePickerIsDisabled}
          notSaved={
            draftScores[enrollments[0].id] ? draftScores[enrollments[0].id].notSaved : false
          }
        />
      </div>
    </Paper>
  );
};

export default HoleScorerTeam;
